module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Server-568f48ef006d9da7f369e1802cb89fa6.svg";